import moment from "moment";
import { startOfYear, addWeeks, addDays, isSunday, startOfWeek, isBefore } from 'date-fns';

export class AssetServiceHelper {

    async getDailyFrequency(startDate , endDate){
        const records = [];
        const currentDate = moment(startDate,"YYYY-MM-DD");
        const lastDate = moment(endDate, "YYYY-MM-DD");
    
        while (currentDate.isSameOrBefore(lastDate)) {
          const record  = currentDate.toDate()
          records.push(record);
          currentDate.add(1, 'day');
        }
    
        return records;
      }
    

    async getDaysForWeeklyFrequency(day, noOfDays, startDate, endDate) {
        try {

            let start = moment(startDate, "YYYY-MM-DD");
            let end = moment(endDate, "YYYY-MM-DD")
            var arr = [];
            // if we haven't yet passed the day of the week that I need:
            let tmp
            if (moment(startDate, "YYYY-MM-DD").isoWeekday() <= day) {
                // then just give me this week's instance of that day
                tmp = moment(startDate, "YYYY-MM-DD").isoWeekday(day);
            } else {
                // otherwise, give me next week's instance of that day
                tmp = moment(startDate).add(1, 'weeks').isoWeekday(day);
            }

            if (tmp.isAfter(start, 'd')) {
                arr.push(tmp.format('YYYY-MM-DD'));
            }
            while (tmp.isBefore(end)) {
                tmp.add(noOfDays, 'days');
                arr.push(tmp.format('YYYY-MM-DD'));
            }
            return arr
        } catch (err) {
            throw err
        }
    }

    async getThirdAndFourthSundaysBetweenDates(startDate, endDate) {

        const sundays: string[] = [];

        const current = moment(startDate).startOf('month');
        const end = moment(endDate).startOf('month');

        for (let month = 0; month < 12; month++) {
            while (current.isBefore(end) || current.isSame(end, 'month')) {
                const firstDayOfMonth = current.day();
                const firstSunday = firstDayOfMonth === 0 ? 1 : 7 - firstDayOfMonth + 1;
                const thirdSunday = firstSunday + 14;
                const fourthSunday = firstSunday + 21;

                if (thirdSunday <= current.daysInMonth()) {
                    sundays.push(current.date(thirdSunday).format('YYYY-MM-DD'));
                }

                if (fourthSunday <= current.daysInMonth()) {
                    sundays.push(current.date(fourthSunday).format('YYYY-MM-DD'));
                }

                current.add(1, 'month');
            }
        }

        return sundays;
    }

    // async getThirdAndFourthSundaysBetweenDates(startDate, endDate) {
    //     const sundays: string[] = [];

    //     for (let start = startDate; start <= endDate; start++) {
    //       for (let month = 0; month < 12; month++) {
    //         const currentMonth = moment().year(start).month(month).startOf('month');

    //         const firstDayOfMonth = currentMonth.day();
    //         const firstSunday = firstDayOfMonth === 0 ? 1 : 7 - firstDayOfMonth + 1;
    //         const thirdSunday = firstSunday + 14;
    //         const fourthSunday = firstSunday + 21;

    //         if (thirdSunday <= currentMonth.daysInMonth()) {
    //           sundays.push(currentMonth.date(thirdSunday).format('YYYY-MM-DD'));
    //         }

    //         if (fourthSunday <= currentMonth.daysInMonth()) {
    //           sundays.push(currentMonth.date(fourthSunday).format('YYYY-MM-DD'));
    //         }
    //       }
    //     }

    //     return sundays;
    //   }

    // async getThirdAndFourthSundaysBetweenDates(startDate, endDate) {
    //     let count = 0;
    //     const sundays: string[] = [];

    //     const current = moment(startDate).startOf('day');
    //     const end = moment(endDate).startOf('day');

    //     while (current.isBefore(end)) {
    //       if (current.day() === 0) {
    //         count++;
    //         if (count === 3 || count === 4) {
    //         sundays.push(current.format('YYYY-MM-DD'));
    //         }
    //       }

    //       current.add(1, 'day');
    //     }

    //     return sundays;
    //   }

    // async getThirdAndFourthSundaysBetweenDates(startDate , endDate) {
    //     let current = startOfWeek(startDate, { weekStartsOn: 1 }); // Assuming week starts on Monday (1)
    //     let count = 0;
    //     const sundays: string[] = [];

    //     while (isBefore(current, endDate)) {
    //       if (isSunday(current)) {
    //         count++;
    //         if (count === 3 || count === 4) {
    //           sundays.push(moment(current).format("YYYY-MM-DD"));
    //         }
    //       }
    //       current = addDays(current, 1);
    //     }

    //     return sundays;
    //   }

    // async getThirdAndFourthSundays(year){
    //     const startOfYearDate = startOfYear(new Date(year, 0, 1));
    //     const thirdSunday = addDays(addWeeks(startOfYearDate, 2), 0); 
    //     const fourthSunday = addDays(addWeeks(startOfYearDate, 3), 0); 

    //     if (!isSunday(thirdSunday)) {
    //       thirdSunday.setDate(thirdSunday.getDate() + (7 - thirdSunday.getDay()));
    //     }

    //     if (!isSunday(fourthSunday)) {
    //       fourthSunday.setDate(fourthSunday.getDate() + (7 - fourthSunday.getDay()));
    //     }

    //     return [moment(thirdSunday).format("YYYY-MM-DD"), moment(fourthSunday).format("YYYY-MM-DD")];
    //   }

    async getMonthlyDates(start, count) {
        var result = [];
        var temp;
        var year = start.getFullYear();
        var month = start.getMonth();
        var startDay = start.getDate();
        for (var i = 0; i < count; i++) {
            temp = new Date(year, month + i, startDay);
            if (temp.getDate() != startDay) temp.setDate(0);
            result.push(moment(temp).format("YYYY-MM-DD"));
        }
        return result;
    }

    async getQuarterlyDates(date, count) {
        var result = [];
        var temp;
        var startDate = moment(date, "YYYY-MM-DD")
        for (var i = 0; i < count; i++) {
            temp = startDate.add(4, 'months').format("YYYY-MM-DD")
            result.push(temp);
        }
        return result;
    }

    async getHalfyearlyDates(date, count) {
        var result = [];
        var temp;
        var startDate = moment(date)
        for (var i = 0; i < count; i++) {
            temp = startDate.add(6, 'months').format("YYYY-MM-DD")
            result.push(temp);
        }
        return result;
    }

    async getYearlyDates(date, count) {
        var result = [];
        var temp;
        var startDate = moment(date)
        for (var i = 0; i < count; i++) {
            temp = startDate.add(1, 'year').format("YYYY-MM-DD")
            result.push(temp);
        }
        return result;
    }

}